import React from "react";
import axios from "axios";
import { Divider, message, Select, Space } from "antd";
import { useState, useEffect } from "react";

import { BILLING_TYPE, BILLING_TYPE_LABELS, CREDIT_TERMS } from "../../constants/billing";
import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";

const UserBillingSettings = ({ userId, billingType, creditTerm }) => {
  const { permissions } = usePermissions();

  const [selectedBillingType, setSelectedBillingType] = useState(billingType);
  const [selectedCreditTerm, setSelectedCreditTerm] = useState(creditTerm);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    setDisabled(!permissions?.includes(PERMISSIONS.UPDATE_BILLING_SETTINGS));
  }, [permissions]);

  const onChange = async ({ nextBillingType, nextCreditTerm }) => {
    if (!nextBillingType || !nextCreditTerm) {
      // Both fields are required by the backend, don't fire until both are set.
      return;
    }

    setSelectedBillingType(nextBillingType);
    setSelectedCreditTerm(nextCreditTerm);

    try {
      await axios.put(`/api/user/${userId}/billing-settings`, {
        billingType: nextBillingType,
        creditTerm: nextCreditTerm,
      });

      message.info("Updated");
    } catch (err) {
      message.error(err.response?.data?.message || "Error when updating Billing Settings.");
    }
  };

  return (
    <>
      <Divider />
      <h4>
        <strong>Billing Settings</strong>
      </h4>
      <p style={{ marginBottom: 16 }}>
        Controls how this merchant is invoiced: Pay Now (settle each invoice by its due date)
        vs. Contra with COD (month-end settlement against COD collections), and the credit
        term used to calculate invoice due dates.
      </p>
      <Space direction="vertical" size="middle">
        <div>
          Billing Type:
          <Select
            placeholder="Not set"
            style={{ width: 260, marginLeft: 10 }}
            disabled={disabled}
            value={selectedBillingType}
            onChange={(nextBillingType) =>
              onChange({ nextBillingType, nextCreditTerm: selectedCreditTerm })
            }
          >
            {Object.values(BILLING_TYPE).map((type) => (
              <Select.Option key={type} value={type}>
                {BILLING_TYPE_LABELS[type]}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          Credit Term (days):
          <Select
            placeholder="Not set"
            style={{ width: 260, marginLeft: 10 }}
            disabled={disabled}
            value={selectedCreditTerm}
            onChange={(nextCreditTerm) =>
              onChange({ nextBillingType: selectedBillingType, nextCreditTerm })
            }
          >
            {CREDIT_TERMS.map((term) => (
              <Select.Option key={term} value={term}>
                {term}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Space>
    </>
  );
};

export default UserBillingSettings;
